/**
 * Typewriter placeholder for the mobile drawer search button.
 *
 * Lives here rather than in snippets/maahi-drawer-search.liquid because the header
 * section is re-rendered client-side (?section_id=...header_section) and injected with
 * innerHTML — which parses <script> tags but never executes them. Loaded from
 * layout/theme.liquid instead, and re-initialises via MutationObserver whenever the
 * header is swapped back in.
 *
 * Pauses itself when the drawer is closed or the tab is hidden, and degrades to plain
 * phrase rotation under prefers-reduced-motion.
 */
(function () {
  'use strict';

  // Diagnostic marker: lets us tell "script never executed" apart from
  // "script executed but found nothing to attach to".
  window.__maahiDrawerSearch = { executed: true, initRuns: 0, started: 0 };

  // Fallback only. The real list comes from the theme setting, read per element
  // from data-phrases (Customise > Theme settings > Search).
  var FALLBACK = [
    'Pure Silk Sarees',
    'Office Wear',
    'Banarasi Saree',
    'Party Wear',
    'Kanjivaram Silk Saree'
  ];

  function phrasesFor(el) {
    var raw = el.getAttribute('data-phrases');
    if (!raw) return FALLBACK;
    var list = [];
    var parts = raw.split('|~|');
    for (var i = 0; i < parts.length; i++) {
      var v = parts[i].trim();
      if (v) list.push(v);
    }
    return list;
  }

  var TYPE_MS = 70; // per character, typing
  var DELETE_MS = 35; // per character, deleting
  var HOLD_MS = 1500; // pause on a finished phrase
  var GAP_MS = 350; // pause between phrases

  function start(el) {
    if (!el || el.dataset.maahiTwReady === '1') return;
    var PHRASES = phrasesFor(el);
    // An empty setting means the merchant wants no animation at all.
    if (!PHRASES.length) return;

    el.dataset.maahiTwReady = '1';

    el.textContent = '';
    var text = document.createTextNode('');
    var caret = document.createElement('span');
    caret.className = 'maahi-drawer-search__caret';
    caret.textContent = '|';
    el.appendChild(text);
    el.appendChild(caret);

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      var r = 0;
      text.nodeValue = PHRASES[0];
      setInterval(function () {
        r = (r + 1) % PHRASES.length;
        text.nodeValue = PHRASES[r];
      }, 3000);
      return;
    }

    var phrase = 0;
    var chars = 0;
    var deleting = false;

    function tick() {
      // Drawer shut or tab in the background: idle cheaply instead of animating.
      if (document.hidden || el.offsetParent === null || !el.isConnected) {
        setTimeout(tick, 400);
        return;
      }

      var full = PHRASES[phrase];
      var delay;

      if (!deleting) {
        chars++;
        text.nodeValue = full.slice(0, chars);
        if (chars >= full.length) {
          deleting = true;
          delay = HOLD_MS;
        } else {
          delay = TYPE_MS;
        }
      } else {
        chars--;
        text.nodeValue = full.slice(0, chars);
        if (chars <= 0) {
          deleting = false;
          phrase = (phrase + 1) % PHRASES.length;
          delay = GAP_MS;
        } else {
          delay = DELETE_MS;
        }
      }

      setTimeout(tick, delay);
    }

    tick();
  }

  function init() {
    window.__maahiDrawerSearch.initRuns++;
    var nodes = document.querySelectorAll('[data-maahi-typewriter]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.maahiTwReady !== '1') window.__maahiDrawerSearch.started++;
      start(nodes[i]);
    }
    return nodes.length;
  }

  function watch() {
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      // Coalesce bursts of mutations into one cheap query per frame.
      requestAnimationFrame(function () {
        queued = false;
        init();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    init();
    watch();

    // Belt and braces: the header section is re-rendered client-side, so the
    // element can arrive after boot and can be swapped out again later. Retry
    // briefly rather than relying on the observer alone.
    var tries = 0;
    var retry = setInterval(function () {
      tries++;
      init();
      if (tries >= 40) clearInterval(retry); // ~10s at 250ms
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
